import * as React from "react";
import * as uuid from "uuid";

import {
  BodyScrollControllerProvider,
  BrowserInformationProvider,
  CustomerCartIdProvider,
  CustomerInformationProvider,
  CustomerSessionProvider,
  FormProvider,
  JoinDrawerProvider,
  JoinFormProvider,
  LocalizationProvider,
  LoginFormProvider,
  OneTimePasswordProvider,
  PresenterForScrollProvider,
  ProminentErrorProvider,
  ReactQueryClientProvider,
} from "../Common";

import {
  DrawerDeliveryProvider,
  MyBagAnalyticsProvider,
  MyBagProvider,
  ReactCheckout2022RouterProvider,
  ReactMyBagFeaturesProvider,
  ReactMyBagInitialStateProvider,
  ReactMyBagLoginAppProvider,
  DeliveryDetailsProvider,
  SuccessProvider,
  useMyBagAnalytics,
  useReactMyBagInitialState,
  ReactCheckout2022DrawerProvider,
  DrawerGiftcardHelpProvider,
} from "./providers";

import { Page } from "./Page";

interface AppProps {
  mountElement: Element;
}

export const App: React.FunctionComponent<AppProps> = (props) => {
  const bodyScrollControllerGuid = React.useMemo(() => {
    return uuid.v4();
  }, []);

  return (
    <FormProvider>
      <ReactCheckout2022RouterProvider>
        <BrowserInformationProvider>
          <BodyScrollControllerProvider guid={bodyScrollControllerGuid}>
            <ReactQueryClientProvider>
              <ProminentErrorProvider>
                <PresenterForScrollProvider>
                  <ReactMyBagInitialStateProvider>
                    <ReactMyBagFeaturesProvider>
                      <LocalizationProvider>
                        <MyBagAnalyticsProvider>
                          <CustomerSessionProvider
                            useInitialState={useReactMyBagInitialState}
                          >
                            <CustomerCartIdProvider
                              useInitialState={useReactMyBagInitialState}
                            >
                              <CustomerInformationProvider
                                useInitialState={useReactMyBagInitialState}
                              >
                                <ReactMyBagLoginAppProvider>
                                  <LoginFormProvider
                                    useInitialState={useReactMyBagInitialState}
                                  >
                                    <JoinFormProvider
                                      useInitialState={
                                        useReactMyBagInitialState
                                      }
                                    >
                                      <OneTimePasswordProvider
                                        useInitialState={
                                          useReactMyBagInitialState
                                        }
                                        useAnalytics={useMyBagAnalytics}
                                      >
                                        <JoinDrawerProvider>
                                          <DrawerDeliveryProvider>
                                            <DrawerGiftcardHelpProvider>
                                              <ReactCheckout2022DrawerProvider>
                                                <MyBagProvider>
                                                  <DeliveryDetailsProvider>
                                                    <SuccessProvider>
                                                      <Page />
                                                    </SuccessProvider>
                                                  </DeliveryDetailsProvider>
                                                </MyBagProvider>
                                              </ReactCheckout2022DrawerProvider>
                                            </DrawerGiftcardHelpProvider>
                                          </DrawerDeliveryProvider>
                                        </JoinDrawerProvider>
                                      </OneTimePasswordProvider>
                                    </JoinFormProvider>
                                  </LoginFormProvider>
                                </ReactMyBagLoginAppProvider>
                              </CustomerInformationProvider>
                            </CustomerCartIdProvider>
                          </CustomerSessionProvider>
                        </MyBagAnalyticsProvider>
                      </LocalizationProvider>
                    </ReactMyBagFeaturesProvider>
                  </ReactMyBagInitialStateProvider>
                </PresenterForScrollProvider>
              </ProminentErrorProvider>
            </ReactQueryClientProvider>
          </BodyScrollControllerProvider>
        </BrowserInformationProvider>
      </ReactCheckout2022RouterProvider>
    </FormProvider>
  );
};
